import React, { Dispatch, SetStateAction } from 'react';

import { Button, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { deleteVendorAgreement } from '~/services/BusinessTraveller/BusinessTravellerService';

import { titleCase } from '~/utils/stringUtils';

import { VendorAgreementItemType } from '../pages/BusinessDetailsPage/Tabs/FrequentFlyerTab';

const AirlineNameMap = {
  qantas: 'Qantas Business Rewards',
  virgin: 'Virgin Australia Business Flyer',
};

const QantasCodeToLevelMap = {
  QFB01: '1',
  QFB02: '2',
  QFB03: '3',
};

const QantasLevelToCodeMap = {
  1: 'QFB01',
  2: 'QFB02',
  3: 'QFB03',
};

interface Props {
  businessId: string;
  item: VendorAgreementItemType;
  index: number;
  frequentFlyerItems: Array<VendorAgreementItemType>;
  setFrequentFlyerItems: (value: SetStateAction<Array<VendorAgreementItemType>>) => void;
  setHasSaved: Dispatch<SetStateAction<boolean>>;
}

export default function FrequentFlyerItem({
  businessId,
  item,
  index,
  frequentFlyerItems,
  setFrequentFlyerItems,
  setHasSaved,
}: Props) {
  function deleteRow(indexToRemove, businessId) {
    const frequentFlyerCopy = [...frequentFlyerItems];

    if (frequentFlyerCopy[indexToRemove].id) {
      deleteVendorAgreement(frequentFlyerCopy[indexToRemove].id, businessId);
    }

    frequentFlyerCopy.splice(indexToRemove, 1); // Remove the selected row
    setFrequentFlyerItems(frequentFlyerCopy);
    setHasSaved(false);
  }

  function onSelectVerified(e, index: number) {
    const { name, value } = e.target;

    const frequentFlyerCopy = [...frequentFlyerItems];
    frequentFlyerCopy[index][name] = value === 'true';

    setFrequentFlyerItems(frequentFlyerCopy);
    setHasSaved(false);
  }

  function onSelectQantasLevel(e, index: number) {
    const { name, value } = e.target;

    const frequentFlyerCopy = [...frequentFlyerItems];
    frequentFlyerCopy[index][name] = QantasLevelToCodeMap[value];

    setFrequentFlyerItems(frequentFlyerCopy);
    setHasSaved(false);
  }

  return (
    <Grid container gap={2} key={item.id} spacing={2}>
      <Grid alignItems="center" container flexDirection="row" size={12}>
        <Grid>
          <Typography fontSize={32} fontWeight="bold">
            {AirlineNameMap[item.vendorName]}
          </Typography>
        </Grid>
        <Grid>
          <Button color="error" variant="outlined" onClick={() => deleteRow(index, businessId)}>
            Delete
          </Button>
        </Grid>
      </Grid>
      <Grid alignItems="center" container flexDirection="row" size={12}>
        <Grid size={1}>
          <Typography>Airline:</Typography>
        </Grid>
        <Grid size={5}>
          <FormControl fullWidth>
            <TextField name="vendorName" value={`${titleCase(item.vendorName)} (${item.vendorCode})`} disabled />
          </FormControl>
        </Grid>
      </Grid>
      <Grid alignItems="center" container flexDirection="row" size={12}>
        <Grid size={1}>
          <Typography>Membership Status:</Typography>
        </Grid>
        <Grid size={5}>
          <FormControl fullWidth>
            <Select
              label="verified"
              name="verified"
              notched={false}
              onChange={(event) => onSelectVerified(event, index)}
              value={item.verified}
            >
              <MenuItem disabled></MenuItem>
              <MenuItem value="true">Verified membership</MenuItem>
              <MenuItem value="false">No membership</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      {item.vendorName === 'qantas' && (
        <Grid alignItems="center" container flexDirection="row" size={12}>
          <Grid size={1}>
            <Typography>Level:</Typography>
          </Grid>
          <Grid size={5}>
            <FormControl fullWidth>
              <Select
                label="QantasLevel"
                name="corporateCode"
                notched={false}
                onChange={(event) => onSelectQantasLevel(event, index)}
                value={QantasCodeToLevelMap[item.corporateCode]}
              >
                <MenuItem disabled></MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
